const config = {
  apiUrl: process.env.GATSBY_API_URL,
  apiKey: process.env.GATSBY_API_KEY,
}

export default config
